export { NvD3Component } from './nvd3.component';
export { NvD3Module } from './nvd3.module';
